import { ArrowLeft as IconArrowLeft } from 'lucide-react'
import CourseImprovement from './CourseImprovement'
import { useCalculatorStore } from '@/store/calculatorStore'

function ImproveGrades({ onBack }: { onBack: () => void }) {
  const allCourses = useCalculatorStore((state) => state.courses)
  const show235 = useCalculatorStore((state) => state.show235)

  const includedCourses = show235
    ? allCourses.filter((course) => course.included && course.is235course)
    : allCourses.filter((course) => course.included)

  return (
    <div className="@container mt-4" data-testid="improve-grades-container">
      <button
        onClick={onBack}
        className="text-sm h-8 rounded-full bg-purple-50 border-purple-300 border flex items-center gap-2 px-3 cursor-pointer hover:bg-purple-100"
        data-testid="back-button"
      >
        <IconArrowLeft className="size-4" />
        Tilbake til dine karakterer
      </button>
      <h2 className="text-2xl font-bold mt-5" data-testid="improve-grades-heading">
        Forbedre karakterer og konkurransepoeng
      </h2>
      <p className="text-base text-warm-gray-700 mt-2 mb-7" data-testid="improve-grades-description">
        Her kan du se hvor mye du kan øke dine konkurransepoeng hvis du
        forbedrer karakterene dine.
      </p>
      <div className="grid grid-cols-[1fr_100px_372px] gap-6 pb-2 border-b border-warm-gray-600 text-sm font-bold" data-testid="course-headers">
        <div className="hidden @min-[700px]:block">Fag</div>
        <div className="hidden @min-[700px]:block">Eksisterende</div>
        <div className="hidden @min-[700px]:block">Forbedret karakter</div>
      </div>
      <div data-testid="course-improvements-list">
        {includedCourses.map((course) => (
          <CourseImprovement key={course.id} {...course} />
        ))}
      </div>
    </div>
  )
}

export default ImproveGrades
